import React, { useMemo, useState, useEffect, useRef } from "react";
import {
  Box,
  Grid,
  Grid2,
  Typography,
  Tabs,
  Tab,
  Paper,
  Avatar,
  IconButton,
  TextField,
  InputAdornment,
  Button,
  Divider,
  Chip,
  Select,
  MenuItem
} from "@mui/material";
import RefreshIcon from '@mui/icons-material/Refresh';
import SearchIcon from "@mui/icons-material/Search";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import CloseIcon from "@mui/icons-material/Close";
import starIcon from '../../assets/icons/starIcon.png';
import defaultImg from '../../assets/images/defaultimg.png';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import Vehiclertypecar from '../../assets/images/vehicleTypeCar.svg';
import Pickupicon from '../../assets/icons/PickupIcon.svg';
import Dropicon from '../../assets/icons/DropIcon.svg';
import config from "../../config/config";
import { useNavigate } from "react-router-dom";
import carIcon from '../../assets/images/vehicleTypeCar.svg';
import {
  makeGetRequestToUrl,
  makePostRequestToUrl,
} from '../commonFunc.jsx';
import altProfile from '../../assets/images/altProfile.png';
import ChatService from './chatservice';
import { usePDF } from "react-to-pdf";
import { Label } from "flowbite-react";
import { useLocation } from "react-router-dom";
var constant = require('../../constant.js');

const SupportChats = () => {
  const navigate = useNavigate();
  const serverUrl = config.serverUrl;
  const chatUrl = config.chatUrl;
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const queryChatId = params.get("chat_id"); 
  const user_type = Number(params.get("user_type")) || 2;
  const chat_id =params.get("chat_id");
  const [query, setQuery] = useState("");
  const [Mainquery, setMainQuery] = useState("");
  const [detailsOpen, setDetailsOpen] = useState(false);
  const [startDateFilter, setStartDateFilter] = useState(dayjs().subtract(1, 'month'));
  const [endDateFilter, setEndDateFilter] = useState(dayjs());
  const [selectedengagementId, setSelectedengagementId] = useState('');
  const [userCustomerChatData, setUserCustomerChatData] = useState([]);
  const [selectedChatId, setSelectedChatId] = useState('');
  const [userCustomData, setUserCustomData] = useState([]);
  const [rows, setRows] = useState([]);
  const [errorMessage, setErrorMessage] = useState('');
  const [tokenExpired, setTokenExpired] = useState(false);
  const cities = JSON.parse(localStorage.getItem('cities'));
  const [cityFilter, setCityFilter] = useState(cities[0].city_id);
  const initialTab = user_type === 1 ? 1 : 0;
  const [tab, setTab] = useState(initialTab);
  const [userTypeFilter, setUserTypeFilter] = useState(user_type);
  const [driverChatDetails, setDriverChatDetails] = useState([]);
  const [userChatDetails, setUserChatDetails] = useState([]);
  const [driverChats, setDriverChats] = useState([]);
  const [userChats, setUserChats] = useState([]);
  const [selectedChat, setSelectedChat] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const [isExporting, setIsExporting] = useState(false);
  const [statusFilter, setStatusFilter] = useState('');
  const [chatTabClicked, setChatTabClicked] = useState(false);
  const [messageText, setMessageText] = useState("");
  const utcOffset = localStorage.getItem('utc_offset');
  const [chatContext, setChatContext] = useState('ADMIN_DRIVER');
  const [visitedTabs, setVisitedTabs] = useState({driver: true,user: false});
  const [userId, setUserId] = useState('');
  // const isFirstRender = useRef(true);
  const [isFromRoute, setIsFromRoute] = useState(!!chat_id);
  const { toPDF, targetRef } = usePDF({
      filename: `chat_export_of_${userTypeFilter == 2 ? selectedRow?.driver_details?.driver_name : selectedRow?.user_details?.user_name}_${userId || 'all'}.pdf`,
      page: {
          margin: 10,
          format: 'a4',
          orientation: 'portrait'
      }
  });

  // Filter for chat list
  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();

    const rawList = userTypeFilter === 2
      ? driverChatDetails
      : userChatDetails;

    const list = Array.isArray(rawList) ? rawList : [];

    return list.filter((c) => {
      if (!c) return false;

      const name =
        userTypeFilter === 2
          ? (c.driver_details?.driver_name || c.driver_details?.driver_id)
          : (c.user_details?.user_name || c.user_details?.user_id);

      return (
        (name || "").toLowerCase().includes(q) ||
        String(c.chat_id).includes(q) || 
        String(c?.driver_details?.driver_id).includes(q) ||
        String(c?.user_details?.user_id).includes(q)
      );
    });

  }, [query, userTypeFilter, driverChatDetails, userChatDetails]);

  const fetchSupportChatLogs = async () => {
    try {

      const url = serverUrl + `/panel/fetch_admin_chat_logs`;
      const token = localStorage.getItem("token");

      const body = {
        token,
        user_type: userTypeFilter,
      };
      if (isFromRoute && chat_id) {
        body.chat_id = chat_id;
      } else {
        body.start_date = startDateFilter.format("YYYY-MM-DD");
        body.end_date = endDateFilter.format("YYYY-MM-DD");
      }

      // if (selectedengagementId) {
      //   body.engagement_id = selectedengagementId;
      // }

      const response = await makeGetRequestToUrl(url, body);

      if (response.flag === 200) {

        /////////////////////////////////////////////
        // CASE 1 — LIST RESPONSE (Array)
        /////////////////////////////////////////////
        if (!selectedengagementId) {
          const list = Array.isArray(response.data) ? response.data : [];
          if (userTypeFilter === 2) {
            // DRIVER LIST
            setDriverChatDetails(list);
            setSelectedChat( null);
          }
          if (userTypeFilter === 1) {
            // USER LIST
            setUserChatDetails(list);
            setSelectedChat(null);
          }
        }

        /////////////////////////////////////////////
        // CASE 2 — CHAT RESPONSE (Object)
        /////////////////////////////////////////////
        if (selectedengagementId) {
          const chatObj = response.data || {};
          console.log(chatObj, "chatObj")

          if (userTypeFilter === 2) {
            // DRIVER CHAT
            setDriverChats(chatObj);
          }
          if (userTypeFilter === 1) {
            // USER CHAT
            setUserChats(chatObj);
          }
        }
      }

      if (response.flag === 102) {
        localStorage.removeItem("token");
        setErrorMessage("Your session has expired. Please log in again.");
        setTokenExpired(true);
        setTimeout(() => navigate("/signup"), 1500);
      }

    } catch (error) {
      console.log("error", error);
    }
  };

useEffect(() => {
  // if (isFirstRender.current) {
  //   isFirstRender.current = false;
  //   return;
  // }
  fetchSupportChatLogs();
}, [cityFilter, startDateFilter, endDateFilter, selectedengagementId, userTypeFilter]);

  useEffect(() => {
    setSelectedChatId('');
    setSelectedChat(null);
    setSelectedRow(null);
    setDriverChats([]);
    setUserChats([]);
    setStartDateFilter(dayjs().subtract(1, 'month'));
    setEndDateFilter(dayjs());
    setStatusFilter('');
    setMessageText('');
    setChatTabClicked(false);
    setDetailsOpen(false);
  }, [userTypeFilter]);

  const handleViewChat = (row) => {
    setChatTabClicked(true);
    setSelectedChatId(row.chat_id);
    setUserId(userTypeFilter == 2 ? row.driver_details.driver_id : row.user_details.user_id);
    // setOpenChat(true);
    setSelectedRow(row);
    setSelectedChat(row);
  };

    useEffect(() => {
    if (!queryChatId || userTypeFilter == 2 && !driverChatDetails?.length || userTypeFilter == 1 && !userChatDetails?.length) return;

    // Find the taxi engagement card
    const found = userTypeFilter == 2 ? driverChatDetails.find(
        (item) => item?.chat_id?.toString() === queryChatId
    ) : userChatDetails.find(
        (item) => item?.chat_id?.toString() === queryChatId
    );

    if (found) {

        // Auto-select card
        handleViewChat(found);

        // Scroll card into view (optional)
        setTimeout(() => {
            const el = document.getElementById(`card-${queryChatId}`);
            if (el) el.scrollIntoView({ behavior: "smooth", block: "center" });
        }, 200);
    }
  }, [queryChatId, userChatDetails, driverChatDetails, userTypeFilter]);

  useEffect(() => {
    setMessageText("");
    setDetailsOpen(false);
  }, [selectedChatId]);

  useEffect(() => {
  setIsFromRoute(false); 
}, [startDateFilter, endDateFilter, userTypeFilter, cityFilter]);

  useEffect(() => {
  if (user_type === 1) {
    setTab(1);
    setUserTypeFilter(1);
    setChatContext("ADMIN_USER");
  } else {
    setTab(0);
    setUserTypeFilter(2);
    setChatContext("ADMIN_DRIVER");
  }
}, [user_type]);




  const fetchSupportChat = async () => {
    try {

      const url = chatUrl + `/chat/get_messages`;
      const token = localStorage.getItem("token");

      const body = {
        // token,
        fetcher_type : 3,
        chat_id : selectedChatId
      };

      if (selectedChatId) {
        body.chat_id = selectedChatId;
      }

      const response = await makeGetRequestToUrl(url, body);

      if (response.flag === 200) {
        if (selectedChatId) {
          const chatObj = response.data || {};

          if (userTypeFilter === 2) {
            // DRIVER CHAT
            setDriverChats(chatObj);
          }
          if (userTypeFilter === 1) {
            // USER CHAT
            setUserChats(chatObj);
          }
        }
      }

      if (response.flag === 102) {
        localStorage.removeItem("token");
        setErrorMessage("Your session has expired. Please log in again.");
        setTokenExpired(true);
        setTimeout(() => navigate("/signup"), 1500);
      }

    } catch (error) {
      console.log("error", error);
    }
  };

    useEffect(() => {
    // Do nothing if no chat is selected
    if (!selectedChatId) return;

    // Initial fetch immediately
    fetchSupportChat();

    // Poll every 5 seconds
    const intervalId = setInterval(() => {
      fetchSupportChat();
    }, 2000);

    // Cleanup when chat changes or component unmounts
    return () => clearInterval(intervalId);

  }, [selectedChatId,userTypeFilter]);

  const sendChatfromAdmin = async (message) => {
    try {

      const url = chatUrl + `/chat/send_message`;
      const token = localStorage.getItem("token");

      const body = {
        // token,
        sender_type : 3,
        chat_id : selectedChatId,
        message : message
      };

      if (selectedChatId) {
        body.chat_id = selectedChatId;
      }

      const response = await makePostRequestToUrl(url, body);

      if (response.flag === 102) {
        localStorage.removeItem("token");
        setErrorMessage("Your session has expired. Please log in again.");
        setTokenExpired(true);
        setTimeout(() => navigate("/signup"), 1500);
      }

    } catch (error) {
      console.log("error", error);
    }
  };

  const handleSendMessage = async () => {
  const trimmed = messageText.trim();
  if (!trimmed || !selectedChatId) return;

  await sendChatfromAdmin(trimmed);

  // clear input
  setMessageText("");

  // fetch latest messages immediately
  fetchSupportChat();
};


  // width logic: when detailsOpen true the middle panel shrinks
  const leftWidth = 330;
  const rightQuickWidth = 260;
  const detailsPanelWidth = detailsOpen ? 420 : 0;
  const middleCalc = `calc(100% - ${leftWidth}px - ${rightQuickWidth}px - ${detailsPanelWidth}px - 48px)`;

  return (
    <div>
      <Typography variant="h5" sx={{ mb: 2 }}>
        Support Chats
      </Typography>

      {/* Top Filters */}
      <Grid container sx={{ mb: 2, gap: 2 }}>
        {/* <Grid item xs={12} md={4}>
          <TextField
            fullWidth
            size="small"
            placeholder="Search here"
            value={Mainquery}
            onChange={(e) => setMainQuery(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon fontSize="small" />
                </InputAdornment>
              ),
            }}
            sx={{
              mb: 1,
              "& .MuiOutlinedInput-root": {
                borderRadius: "8px",
                backgroundColor: "#fff",
              }
            }}
          />

        </Grid>

        <Grid2 item>
            <Select value={statusFilter} 
            onChange={(e) => setStatusFilter(e.target.value)} displayEmpty
            style={{width: '140px',height:'40px',borderRadius:'8px',backgroundColor: statusFilter ? '#F9F9F9' : '#FFFFFF'}}>
                <MenuItem value="">All</MenuItem>
                <MenuItem value="1">Active</MenuItem>
                <MenuItem value="2">Pending</MenuItem>
                <MenuItem value="3">Resolved</MenuItem>
            </Select>
        </Grid2> */}
        
          <Grid2 item>
                <Label>Start Date:</Label><br/>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                        slotProps={{ 
                            textField: { 
                                size: 'small',
                                error: endDateFilter && startDateFilter && startDateFilter.isAfter(endDateFilter)
                            } 
                        }}
                        sx={{
                            width: '190px',
                            '& .MuiInputBase-root': {
                                minHeight: '44px',
                                borderRadius: '8px',
                                backgroundColor: '#FFFFFF',
                                minWidth:'190px',
                                marginTop: '4px'
                            }
                        }}
                        // format={date_format_dd_mm_yy ? "DD/MM/YYYY" : "YYYY/MM/DD"}
                        value={startDateFilter}
                        onChange={(newValue) => setStartDateFilter(newValue)}
                        renderInput={(params) => <TextField {...params} style={{ width: '200px', }} />}
                        maxDate={endDateFilter || undefined}
                    />
                </LocalizationProvider>
            </Grid2>
        

        <Grid2 item>
                <Label>End Date:</Label><br/>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                        // format={date_format_dd_mm_yy ? "DD/MM/YYYY" : "YYYY/MM/DD"}
                        slotProps={{ 
                            textField: { 
                                size: 'small',
                                error: endDateFilter && startDateFilter && startDateFilter.isAfter(endDateFilter)
                            } 
                        }}
                        sx={{
                            width: '190px',
                            '& .MuiInputBase-root': {
                                minHeight: '44px',
                                borderRadius: '8px',
                                backgroundColor: '#FFFFFF',
                                minWidth:'190px',
                                marginTop: '4px'
                            }
                        }}
                        value={endDateFilter}
                        onChange={(newValue) => setEndDateFilter(newValue)}
                        renderInput={(params) => <TextField {...params} style={{ width: '200px' }} />}
                        minDate={startDateFilter || undefined}
                    />
                </LocalizationProvider>
            </Grid2>
            <Grid2 item sx={{ display: 'flex', alignItems: 'flex-end', mt: 3 }}>
                <IconButton 
                    onClick={() => {
                        setIsFromRoute(false);
                        fetchSupportChatLogs();
                    }}
                    sx={{ 
                        mb: 1,
                        backgroundColor: '#f6f6f6',
                        border:'1px solid #0065FF',
                        borderRadius:'12px',
                        color:'#0065FF',
                        '&:hover': {
                            backgroundColor: '#e0e0e0'
                        }
                    }}
                    title="Refresh chats"
                >
                    <RefreshIcon />
                </IconButton>
            </Grid2>
      </Grid>

      {/* Main 3-column layout */}
      <Box sx={{ display: "flex", height: "auto", border: "1px solid #DADADA", borderRadius: "8px" }}>
        {/* LEFT: Chat List */}
        <Paper
          elevation={0}
          sx={{
            width: leftWidth,
            // p: 2,
            borderRadius: "8px 0px 0px 8px",
            bgcolor: "#fff",
            border: "1px solid #EFEFF0",
            maxHeight: "74vh",
            overflowY: "auto",
          }}
        >
          <Box sx={{ p: 2 }}>
            <TextField
              fullWidth
              size="small"
              placeholder="Search here"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon fontSize="small" />
                  </InputAdornment>
                ),
              }}
              sx={{
                mb: 1,
                "& .MuiOutlinedInput-root": {
                  borderRadius: "30px",
                }
              }}
            />
          </Box>


          <Tabs
            value={tab}
            onChange={(e, v) => {
              setTab(v);
              // Mark the tab as visited when clicked
              if (v === 0) {
                setVisitedTabs(prev => ({ ...prev, driver: true }));
                setUserTypeFilter(2);
              } else {
                setVisitedTabs(prev => ({ ...prev, user: true }));
                setUserTypeFilter(1);
              }
            }}
            centered
            sx={{
              borderTop: "1px solid #DADADA",
              borderBottom: "1px solid #FFFFFF",
              mt: -0.65,
              '& .MuiTabs-indicator': {
                backgroundColor: '#0065FF', 
                height: 4,
              },
              '& .MuiTab-root': {
                textTransform: 'none',
                minWidth: '150px',
                px: 2,
                color: '#666',
                '&.Mui-selected': {
                  color: '#0065FF'
                }
              }
            }}
          >
            <Tab 
              label={`Driver ${visitedTabs.driver ? `(${driverChatDetails.length})` : ''}`} 
              onClick={() => setChatContext("ADMIN_DRIVER")}
            />
            <Tab 
              label={`User ${visitedTabs.user ? `(${userChatDetails.length})` : ''}`} 
              onClick={() => setChatContext("ADMIN_USER")}
            />
          </Tabs>

          <Box sx={{ overflowY: "auto", height: "57vh", background: "#FFFFFF",pt:1,borderTop:'1px solid #EFEFF0',borderRadius:'8px' }} >
            {filtered.map((c, i) => {
              // console.log(c,"c")
              const active = selectedChat?.chat_id === c.chat_id;

              return (
                <Paper
                  key={c.chat_id + i}
                  onClick={() => handleViewChat(c)}
                  elevation={0}
                  sx={{
                    p: "16px 12px",
                    margin: "0 12px",
                    borderRadius: "16px",
                    cursor: "pointer",
                    border: active ? "2px solid #6BA6FF" : "1px solid #D6E4FF",
                    backgroundColor: "#F7FAFF",
                    boxShadow: active ? "0px 4px 10px rgba(30,111,255,0.12)" : "none",
                    transition: "0.2s",
                    marginBottom: "10px",
                    cursor: "pointer",
                  }}
                >
                  <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }} >
                    {/* LEFT SECTION */}
                    <Box sx={{ display: "flex", alignItems: "flex-start" }}>
                      <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", minWidth: 60 }}>
                        <Avatar
                          src={userTypeFilter === 2 ? c.driver_details?.driver_image || altProfile : c.user_details?.user_image || altProfile}
                          sx={{ width: 46, height: 46 }}
                        />
                        <Box sx={{ textAlign: "center", mt: 1 }}>
                          <Typography sx={{ fontSize: 11, color: "#444" }}>
                            {c.chat_summary?.last_message_at
                              ? dayjs(c.chat_summary.last_message_at).format("MMM D, YYYY")
                              : "--"}
                          </Typography>
                          <Typography sx={{ fontSize: 13, fontWeight: 600, color: "#1A1E25", mt: "-2px" }}>
                            {c.chat_summary?.last_message_at
                              ? dayjs.utc(c.chat_summary.last_message_at).add(utcOffset, "minutes").format("hh:mm a")
                              : "--"}
                          </Typography>
                        </Box>
                      </Box>
                      <Box>
                        {/* Name & ID */}
                        <Typography sx={{ fontWeight: 700, fontSize: 15, color: "#1A1E25" }}>
                          {userTypeFilter === 2 ? c.driver_details?.driver_name : c.user_details?.user_name}
                        </Typography>
                        <Typography sx={{ color: "#1A1E25", fontSize: 16, mt: "2px" }}>
                          ID: {userTypeFilter === 2 ? c.driver_details?.driver_id : c.user_details?.user_id}
                        </Typography>
                      </Box>
                    </Box>

                    {/* RIGHT SECTION */}
                    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-end" }}>
                      {/* Car Icon */}
                      <img
                        src={carIcon}
                        alt="car"
                        style={{ width: 38, marginBottom: 6 }}
                      />



                      {/* Status + Dot */}
                      <Box sx={{ display: "flex", alignItems: "center", mt: 1, gap: 0.7 }}>
                        <FiberManualRecordIcon sx={{ color: "#31C26A", fontSize: 14 }} />
                        <Typography sx={{ fontSize: 13, fontWeight: 600, color: "#31C26A" }}>
                          Active
                        </Typography>
                      </Box>

                      {/* Unread bubble */}
                      {c.unread > 0 && (
                        <Box
                          sx={{
                            mt: 1,
                            width: 22,
                            height: 22,
                            borderRadius: "50%",
                            backgroundColor: "#1A1E25",
                            color: "white",
                            fontSize: "12px",
                            fontWeight: 600,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          {c.unread}
                        </Box>
                      )}
                    </Box>
                  </Box>
                  <hr style={{ borderStyle: "dashed", color: "#CCCDCE" }} />
                  <Box>
                    {/* Last Message */}
                    <Typography
                      sx={{
                        mt: 1,
                        fontSize: 13,
                        color: "#1A1E25",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        maxWidth: "190px",
                        fontWeight: 500,
                      }}
                    >
                      <span style={{ fontWeight: 600, color: userTypeFilter === 1 ? "#0065FF" : "#4E545D" }}>{userTypeFilter == 2 ? "Driver" : "User"} : </span>
                      <span style={{ color: "#4E545D" }}>
                        {c.chat_summary?.last_message ? c.chat_summary?.last_message : "Yet to initialize chat"}
                      </span>
                    </Typography>
                  </Box>
                </Paper>

              );
            })}
          </Box>
        </Paper>

        {/* RIGHT: Chat area */}

        {!selectedChatId ? (
            <Box
              sx={{
                flex: 1,
                display: "flex",
                alignItems: "center",
                backgroundColor: "#fff",
                justifyContent: "center",
                flexDirection: "column",
                color: "#0165ff",
                gap: 1,
                border:'1px solid #DADADA',
                borderRadius: "0px 8px 8px 0px",

              }}
            >
              <Typography variant="h6" sx={{ fontWeight: 600 }}>
              {`No ${userTypeFilter === 2 ? "Driver" : "User"} chat ${
                userTypeFilter === 2 
                  ? (driverChatDetails?.length === 0 ? "available between " + startDateFilter.format("DD-MMM-YYYY") + " and " + endDateFilter.format("DD-MMM-YYYY") : "selected")
                  : (userChatDetails?.length === 0 ? "available between " + startDateFilter.format("DD-MMM-YYYY") + " and " + endDateFilter.format("DD-MMM-YYYY") : "selected")
              }`}              
              </Typography>
              <Typography sx={{ fontSize: 14 }}>
              {`Please ${
                (userTypeFilter === 2 && driverChatDetails?.length === 0) || 
                (userTypeFilter !== 2 && userChatDetails?.length === 0) 
                  ? `wait for the ${userTypeFilter === 2 ? "Driver" : "User"} Chat to be available` 
                  : `select a conversation from the ${userTypeFilter === 2 ? "Driver" : "User"} panel to view messages.`
              }`}             
               </Typography>
            </Box>
          ) : (
            <>
        <Paper
          elevation={0}
          sx={{
            flex: 1,
            minWidth: middleCalc,
            background: "#fff",
            borderRadius: "0px 8px 8px 0px",
            border: "1px solid #efefef",
            display: "flex",
            flexDirection: "column",
            height: "74vh",
            transition: "min-width 0.25s ease",
          }}
        >
          {/* Header */}
          <Box sx={{ p: 2, borderBottom: "1px solid #f0f0f0", display: "flex", alignItems: "center", justifyContent: "space-between", boxShadow: "0 2px 4px rgba(0,0,0,0.05)" }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Avatar src={userTypeFilter == 2 ? (selectedRow?.driver_details?.driver_image || altProfile) : (selectedRow?.user_details?.user_image || altProfile)} />
              <Box>
                <Typography sx={{ fontWeight: 700 }}>{userTypeFilter == 2 ? selectedRow?.driver_details?.driver_name : selectedRow?.user_details?.user_name}</Typography>
                <Typography sx={{ fontSize: 12, color: "#8a8a8a" }}>On: {dayjs.utc(selectedRow?.chat_summary?.last_message_at).add(utcOffset, 'minutes').format("MMM D, YYYY hh:mm a")}</Typography>
              </Box>
            </Box>
            <Grid2 sx={{ display: 'flex', alignItems: 'center' }}>

              <Grid2 item>
                <Button onClick={() => setDetailsOpen(true)} sx={{
                  backgroundColor: '#FFF',
                  color: '#1A1E25',
                  borderRadius: '8px',
                  padding: '6px 12px',
                  marginRight: '8px',
                  fontSize: '14px',
                  fontWeight: 400,
                  textTransform: 'none',
                  border: '1px solid #1A1E25',
                  '&:hover': {
                    backgroundColor: '#1A1E25',
                    color: '#fff',
                  },
                }}>
                  View Details
                </Button>
              </Grid2>

              <Grid2 xs="auto">
                <Button
                  variant="contained"
                  style={{
                    width: "120px",
                    height: "42px",
                    backgroundColor: "#1A1E25",
                    textTransform: "none",
                    borderRadius: "8px",
                    marginRight: "8px"
                  }}
                onClick={async () => {
                  setIsExporting(true);

                  // wait for DOM reflow before exporting
                  setTimeout(() => {
                    toPDF();
                    setIsExporting(false);
                  }, 300);
                }}

                // disabled={!usercustomdata}
                >
                  <Typography sx={{ color: "#fff", cursor: "pointer" }}>Export Chat</Typography>
                </Button>
              </Grid2>
            </Grid2>
          </Box>

          {/* <ChatService messages={userTypeFilter == 2 ? driverChats.chat_messages : userChats.chat_messages} engagementId={selectedengagementId} searchicon={true} /> */}
             {/* CHAT UI  */}
            <ChatService
                messages={
                  userTypeFilter === 2
                    ? driverChats?.messages || []
                    : userChats?.messages || []
                }
                searchicon={true}
                chatId={selectedChatId}
                chatContext={chatContext}
                messageText={messageText}
                setMessageText={setMessageText}
                sendMessage={handleSendMessage}
              />


        </Paper>
        <Paper
          elevation={0}
          sx={{
            maxWidth: '75vw',
            margin: '10px auto',
            backgroundColor: '#FFFFFF',
            borderRadius: '12px',
            border: '1px solid #DADADA',
            position: 'absolute', 
            top: '-10000px', 
            left: '-10000px', 
            width: '100%',
            height: 'auto'
          }}
          ref={targetRef}
        >
          {/* Header */}
          <Box sx={{ p: 2, borderBottom: "1px solid #f0f0f0", display: "flex", alignItems: "center", justifyContent: "space-between", boxShadow: "0 2px 4px rgba(0,0,0,0.05)" }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Avatar src={userTypeFilter == 2 ? (selectedRow?.driver_details?.driver_image || altProfile) : (selectedRow?.user_details?.user_image || altProfile)} />
              <Box>
                <Typography sx={{ fontWeight: 700 }}>{userTypeFilter == 2 ? selectedRow?.driver_details?.driver_name : selectedRow?.user_details?.user_name}</Typography>
                <Typography sx={{ fontSize: 12, color: "#8a8a8a" }}>On: {dayjs(selectedRow?.chat_summary?.last_message_at).format("MMM D, YYYY hh:mm a")}</Typography>
              </Box>
            </Box>
            <Grid2 sx={{ display: 'flex', alignItems: 'center' }}>


            </Grid2>
          </Box>

          {/* <ChatService messages={userTypeFilter == 2 ? driverChats.chat_messages : userChats.chat_messages} engagementId={selectedengagementId} searchicon={true} /> */}
             {/* CHAT UI  */}
            <ChatService
              messages={
                userTypeFilter === 2
                  ? driverChats?.messages || []
                  : userChats?.messages || []
              }
              chatId={selectedChatId}
              chatContext={chatContext}
              searchicon={true}
              isExporting={isExporting}
              // overflowstyle={isExporting ? "unset" : "auto"}

            />

        </Paper>
        </>
          )}

        {/* DETAILS PANEL (slides in when open) */}
        {detailsOpen && (
          <Paper
            elevation={6}
            sx={{
              width: detailsPanelWidth,
              position: "fixed",
              right: 0,
              top: 67,
              backgroundColor: "#F9F9F9",
              bottom: 2,
              borderRadius: 2,
              p: 2,
              overflowY: "auto",
              transition: "all 0.28s ease",
              zIndex: 1500,
              boxShadow: "none",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 1 }}>
              <Typography variant="h6" sx={{ fontWeight: 700 }}>
                View Details
              </Typography>
              <IconButton onClick={() => setDetailsOpen(false)}>
                <CloseIcon />
              </IconButton>
            </Box>

            {/* Driver Details Card */}
            <Paper
              style={{
                padding: '20px 20px 5px 20px',
                marginTop: '20px',
                backgroundColor: '#fff',
                borderRadius: '12px',
                boxShadow: 'none',
              }}
            >
              <Typography style={{ fontWeight: 600, marginBottom: 10 }}>{`${userTypeFilter === 2 ? "Driver" : "User"}`} Details</Typography>

              <div style={{ display: 'flex', alignItems: 'center', marginBottom: 15 }}>
                <Avatar src={userTypeFilter === 2 ? (selectedRow?.driver_details?.driver_image || altProfile) : selectedRow?.user_details?.user_image || altProfile} sx={{ width: 60, height: 60 }} />
                <div style={{ marginLeft: 12 }}>
                  <Typography style={{ fontWeight: 600 }}>{userTypeFilter === 2 ? selectedRow?.driver_details?.driver_name : selectedRow?.user_details?.user_name}</Typography>

                  {/* Rating Row */}
                  <div style={{ display: 'flex', alignItems: 'center', marginTop: 4 }}>
                    {/* <img src={starIcon} alt="Rating" style={{ width: 15 }} /> */}
                    <Typography style={{ fontSize: 14 }}>{`${userTypeFilter === 2 ? selectedRow?.driver_details?.driver_rating : selectedRow?.user_details?.user_rating} Reviews`}</Typography>
                  </div>
                </div>
              </div>

              {/* Details Grid */}
              <Grid2 container spacing={2} sx={{ marginBottom: '10px', justifyContent: 'space-between' }}>
                <Grid2 xs={6}><Typography><b style={{ fontWeight: 400, color: "#1A1E25", fontSize: '12px' }}>{`${userTypeFilter === 2 ? "Driver ID" : "User ID"}`}</b><br />{`${userTypeFilter === 2 ? selectedRow?.driver_details?.driver_id : selectedRow?.user_details?.user_id}`}</Typography></Grid2>
                <Grid2 xs={6} sx={{ marginLeft: '6.5rem' }}><Typography><b style={{ fontWeight: 400, color: "#1A1E25", fontSize: '12px' }}>Mobile Number</b><br />{`${userTypeFilter === 2 ? selectedRow?.driver_details?.driver_phone_number : selectedRow?.user_details?.user_phone_number}`}</Typography></Grid2>
                <Grid2 xs={6}><Typography>{""}</Typography></Grid2>
              </Grid2>
              <Grid2 container spacing={2} sx={{ marginBottom: '10px', justifyContent: 'space-between' }}>
                <Grid2 xs={6}><Typography><b style={{ fontWeight: 400, color: "#1A1E25", fontSize: '12px' }}>Email</b><br />{`${userTypeFilter === 2 ? selectedRow?.driver_details?.driver_email : selectedRow?.user_details?.user_email}`}</Typography></Grid2>
                <Grid2 xs={6}><Typography><b style={{ fontWeight: 400, color: "#1A1E25", fontSize: '12px' }}>City</b><br />{`${userTypeFilter === 2 ? selectedRow?.driver_details?.driver_city_name : selectedRow?.user_details?.user_city_name}`}</Typography></Grid2>
                <Grid2 xs={6}><Typography><b style={{ fontWeight: 400, color: "#1A1E25", fontSize: '12px' }}>Trips</b><br />{`${userTypeFilter === 2 ? selectedRow?.driver_details?.driver_total_trips : selectedRow?.user_details?.user_total_trips}`}</Typography></Grid2>
              </Grid2>
            </Paper>

            {/* Rider Details */}
            {false && <Paper
              style={{
                padding: '20px 20px 5px 20px',
                marginTop: '20px',
                backgroundColor: '#fff',
                borderRadius: '12px',
                boxShadow: 'none',
              }}
            >
              <Typography style={{ fontWeight: 600, marginBottom: 10 }}>Rider Details</Typography>

              <div style={{ display: 'flex', alignItems: 'center', marginBottom: 15 }}>
                <Avatar src={altProfile} sx={{ width: 60, height: 60 }} />
                <div style={{ marginLeft: 12 }}>
                  <Typography style={{ fontWeight: 600 }}>John Paul</Typography>

                  {/* Rating */}
                  <div style={{ display: 'flex', alignItems: 'center', marginTop: 4 }}>
                    <img src={starIcon} alt="Rating" style={{ width: 15 }} />
                    <Typography style={{ fontSize: 14, marginLeft: 6 }}>(50 Reviews)</Typography>
                  </div>
                </div>
              </div>

              {/* Details */}
              <Grid2 container spacing={2} sx={{ marginBottom: '10px', justifyContent: 'space-between' }}>
                <Grid2 xs={6}><Typography><b style={{ fontWeight: 400, color: "#1A1E25", fontSize: '12px' }}>User ID</b><br /></Typography></Grid2>
                <Grid2 xs={6} sx={{ marginLeft: '65px' }}><Typography><b style={{ fontWeight: 400, color: "#1A1E25", fontSize: '12px' }}>Mobile Number</b><br />+1 62000 00001</Typography></Grid2>
                <Grid2 xs={6}><Typography>{""}</Typography></Grid2>

              </Grid2>
              <Grid2 container spacing={2} sx={{ marginBottom: '10px', justifyContent: 'space-between' }}>
                <Grid2 xs={6}><Typography><b style={{ fontWeight: 400, color: "#1A1E25", fontSize: '12px' }}>Email</b><br />johnpaul@gmail.com</Typography></Grid2>
                <Grid2 xs={6}><Typography><b style={{ fontWeight: 400, color: "#1A1E25", fontSize: '12px' }} >City</b><br />New York, USA</Typography></Grid2>
                <Grid2 xs={6}><Typography><b style={{ fontWeight: 400, color: "#1A1E25", fontSize: '12px' }}>Trips</b><br />20</Typography></Grid2>
              </Grid2>
            </Paper>}


            {/* TRIP DETAILS */}
            {false &&<Paper
              style={{
                padding: '20px 20px 5px 20px',
                marginTop: '20px',
                backgroundColor: '#fff',
                borderRadius: '12px',
                boxShadow: 'none',
              }}
            >
              <Typography style={{ fontWeight: 600, marginBottom: 10 }}>Trip Details</Typography>

              <Grid2 container spacing={2} sx={{ marginBottom: '10px', justifyContent: 'space-between' }}>
                <Grid2 xs={6}><Typography><b style={{ fontWeight: 400, color: "#1A1E25", fontSize: '12px' }}>Booking ID</b><br />MIBI0001</Typography></Grid2>
                <Grid2 xs={6}><Typography><b style={{ fontWeight: 400, color: "#1A1E25", fontSize: '12px' }}>Booking Type</b><br />+1 62000 00001</Typography></Grid2>
                <Grid2 xs={6}><Typography>{""}</Typography></Grid2>
              </Grid2>
              <Grid2 container spacing={2} sx={{ marginBottom: '10px', justifyContent: 'space-between' }}>
                <Grid2 xs={6}><Typography><b style={{ fontWeight: 400, color: "#1A1E25", fontSize: '12px' }}>Vehicle Type</b><br />johnpaul@gmail.com</Typography></Grid2>
                <Grid2 xs={6}><Typography><b style={{ fontWeight: 400, color: "#1A1E25", fontSize: '12px' }}>Ride start Time</b><br />New York, USA</Typography></Grid2>
                <Grid2 xs={6}><Typography><b style={{ fontWeight: 400, color: "#1A1E25", fontSize: '12px' }}>Booking Distance</b><br />20</Typography></Grid2>
              </Grid2>
              <hr></hr>
              {/* Locations */}
              <div style={{ marginTop: 20 }}>
                <Typography style={{ display: 'flex', alignItems: 'center' }}>
                  <img src={Pickupicon} alt="Pickup" style={{ width: 20, height: 20, marginRight: 8 }} /><span>Pickup Location</span>
                </Typography>
                <Typography style={{ fontWeight: 400, marginBottom: 10, marginLeft: '28px' }}>
                  20 Cooper Square, New York, NY 10003, USA
                </Typography>

                <Typography style={{ display: 'flex', alignItems: 'center', marginTop: 10 }}>
                  <img src={Dropicon} alt="Drop" style={{ width: 20, height: 20, marginRight: 8 }} />  <span>Drop Location</span>
                </Typography>
                <Typography style={{ fontWeight: 400, marginBottom: 10, marginLeft: '28px' }}>
                  400 Broome St, New York, NY 10013, USA
                </Typography>
              </div>
            </Paper>}


            {/* VEHICLE DETAILS */}
            {false &&<Paper
              style={{
                padding: '20px 20px 5px 20px',
                marginTop: '20px',
                backgroundColor: '#fff',
                borderRadius: '12px',
                boxShadow: 'none',
              }}
            >
              <Typography style={{ fontWeight: 600, marginBottom: 10 }}>Vehicle Details</Typography>

              <Grid2 container spacing={2}>
                <Grid2 xs={4}>
                  <img src={Vehiclertypecar}
                    alt="Car"
                    style={{ width: 80 }}
                  />
                </Grid2>


                <Grid2 container spacing={2} sx={{ marginBottom: '10px', justifyContent: 'space-between' }}>
                  <Grid2 xs={6}><Typography><b style={{ fontWeight: 400, color: "#1A1E25", fontSize: '12px' }}>Car Name</b><br />Honda City</Typography></Grid2>
                </Grid2>
                <Grid2 container sx={{ marginBottom: '10px', justifyContent: 'space-between', gap: '30px' }}>
                  <Grid2 xs={6}><Typography><b style={{ fontWeight: 400, color: "#1A1E25", fontSize: '12px' }}>Vehicle Number</b><br />GXB4512</Typography></Grid2>
                  <Grid2 xs={6}><Typography><b style={{ fontWeight: 400, color: "#1A1E25", fontSize: '12px' }}>Vehicle Type</b><br />Suv</Typography></Grid2>
                  <Grid2 xs={6}><Typography><b style={{ fontWeight: 400, color: "#1A1E25", fontSize: '12px' }}>Seats</b><br />20</Typography></Grid2>
                  <Grid2 xs={6}><Typography><b style={{ fontWeight: 400, color: "#1A1E25", fontSize: '12px' }}>Booking Distance</b><br />20</Typography></Grid2>
                </Grid2>
              </Grid2>
            </Paper>}


            {/* PAYMENT DETAILS */}
            {false &&<Paper
              style={{
                padding: '20px 20px 5px 20px',
                marginTop: '20px',
                marginBottom: '15px',
                backgroundColor: '#fff',
                borderRadius: '12px',
                boxShadow: 'none',
              }}
            >
              <Typography style={{ fontWeight: 600, marginBottom: 10 }}>Payment Details</Typography>

              <Grid2 container spacing={2} sx={{ marginBottom: '10px', justifyContent: 'space-between' }}>
                <Grid2 xs={6}><Typography><b style={{ fontWeight: 400, color: "#1A1E25", fontSize: '12px' }}>Vehicle Type</b><br />johnpaul@gmail.com</Typography></Grid2>
                <Grid2 xs={6}><Typography><b style={{ fontWeight: 400, color: "#1A1E25", fontSize: '12px' }}>Ride start Time</b><br />New York, USA</Typography></Grid2>
                <Grid2 xs={6}><Typography><b style={{ fontWeight: 400, color: "#1A1E25", fontSize: '12px' }}>Booking Distance</b><br />20</Typography></Grid2>
              </Grid2>
            </Paper>}
          </Paper>
        )}
      </Box>
    </div>
  );
}


export default SupportChats;